import {getAxios} from './axios'

export function getMemberPhoto(id) {
    let axios = getAxios();

    return axios.request({
        url: '/member_photo/',
        method: 'get',
        params: {id}
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/memberPhoto.js